module.exports = __webpack_public_path__ + "media/react/components/PatientBox/RentalStatus/assets/icon_center_unconfirmed-2f95a20d44f0983f40c75218bff9f432.svg";